var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 10.8815V15.0002H4.11881L12.3564 6.76265L8.23751 2.6438L0 10.8815ZM3.59402 13.7329L2.53459 13.733V12.4656H1.26733V11.4061L2.16831 10.5051L4.495 12.8318L3.59402 13.7329ZM8.55461 4.32703C8.69963 4.32703 8.77225 4.39968 8.77225 4.54481C8.77225 4.61091 8.74922 4.66691 8.70293 4.71321L3.33656 10.0795C3.29034 10.1256 3.23419 10.1487 3.16823 10.1487C3.02314 10.1487 2.95049 10.076 2.95049 9.93099C2.95049 9.86489 2.97358 9.80888 3.01974 9.76259L8.38614 4.39632C8.43223 4.35012 8.48837 4.32703 8.55461 4.32703Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6338 2.69293L12.3072 0.376193C12.0564 0.125502 11.756 0 11.4061 0C11.0495 0 10.7527 0.125502 10.5151 0.376193L8.87158 2.00986L12.9905 6.12864L14.634 4.48515C14.8782 4.24091 15.0003 3.94389 15.0003 3.59402C15.0001 3.25087 14.8781 2.95045 14.6338 2.69293Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.ae7dcffd4626c9f6bedd40984ccbf39e.svg";
export { ForwardRef as ReactComponent };